module.exports = __webpack_public_path__ + "static/team-4-21e5e4834350e840d58ba4688187d855.png";